import { Button, Stack, Typography } from "@mui/material"
import { DownloadProcessSteps } from "./DataDownloadProcess"
import StepperDUC from "../duc/StepperDUC"
import { stepLabels } from "./DataDownloadProcess"
import { colours } from "../../StyleConstants"
import Selector from "./components/Selector"


const dummyData = [
    { title: "ABCD", info: "Information about the study", current: true },
    { title: "HBCD", info: "Information about the study", current: false }
]

const StudySelection = (props: any) => {

    const handleClickStudy = (studyTitle: string) => {
        props.setInfo({ ...props.info, study: studyTitle })
        props.setCurStep(DownloadProcessSteps.ReleaseSelection)
    };

    return (
        <Stack gap={3} sx={{ padding: 3 }}>
            <Stack flexDirection="column" gap={4} alignItems="center">
                <Typography
                    variant="h3"
                    fontWeight="600"
                    fontSize="40px"
                    textAlign="center"
                    color={colours.midnightBlue.blue}>
                    New Dataset Download
                </Typography>
                <StepperDUC
                    activeStep={DownloadProcessSteps.StudySelection}
                    stepLabels={stepLabels}
                />
            </Stack>

            <Stack direction="row" justifyContent="space-between" marginTop={3}>
                <Button
                    variant="tertiary"
                    onClick={() => {props.setInfoScreen(true)}}
                >
                    Back
                </Button>
                {/*<Button*/}
                {/*    variant="secondary"*/}
                {/*>*/}
                {/*    Go to current dataset*/}
                {/*</Button>*/}
            </Stack>

            <Typography variant="h5" fontWeight="600" color={colours.midnightBlue.blue}>
                Select Study
            </Typography>

            <Stack gap={2} sx={{ width: '100%' }}>
                {dummyData.map((study) => (
                    <Selector
                        key={study.title}
                        title={study.title}
                        hover={true}
                        handleClick={handleClickStudy}
                        clickInfo={study.title}
                        text="Information about the study"
                    />
                ))}
            </Stack>
        </Stack>
    )
}

export default StudySelection;